// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================= */
/* 🌿 Main Footer Section   */
/* ========================= */
.footer {
  background-color: #00703C;
  color: white;
  padding: 2rem 1rem 1rem;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
  margin-top: 3rem;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 1100px;
  margin: auto;
}

/* Left Section */
.footer-logo {
  flex: 1 1;
  min-width: 250px;
  text-align: center;
}

.footer-logo img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: white;
  margin-bottom: 0.5rem;
}

.footer-logo h3 {
  margin: 0.2rem 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.footer-motto {
  font-style: italic;
  color: #FFD700;
  font-size: 0.9rem;
}

/* ABN display — required by NAB */
.footer-abn {
  font-size: 0.82rem;
  color: rgba(255,255,255,0.75);
  margin: 0.15rem 0;
}

/* Middle Section */
.footer-links {
  flex: 1 1;
  min-width: 200px;
}

.footer-links h4 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  border-bottom: 2px solid #E22B2B;
  display: inline-block;
  padding-bottom: 3px;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin: 0.4rem 0;
}

.footer-links a {
  color: white;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #FFD700;
}

/* Right Section */
.footer-contact {
  flex: 1 1;
  min-width: 200px;
}

.footer-contact h4 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  border-bottom: 2px solid #E22B2B;
  display: inline-block;
  padding-bottom: 3px;
}

.footer-contact p {
  margin: 0.3rem 0;
  font-size: 0.95rem;
}

/* Legal links — Privacy Policy, Refund Policy */
.footer-legal-links {
  list-style: none;
  padding: 0;
  margin: 0.4rem 0 1rem;
}

.footer-legal-links li {
  margin: 0.3rem 0;
}

.footer-legal-links a {
  color: #FFD700;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s;
}

.footer-legal-links a:hover {
  text-decoration: underline;
}

/* NAB payment security note */
.footer-payment-note {
  font-size: 0.8rem;
  color: rgba(255,255,255,0.75);
  background: rgba(0,0,0,0.15);
  border-radius: 6px;
  padding: 8px 10px;
  margin-top: 0.75rem;
  line-height: 1.6;
}

/* Bottom Bar */
.footer-bottom {
  text-align: center;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  padding-top: 0.8rem;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.85);
}

/* Responsive Footer */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .footer-links h4,
  .footer-contact h4 {
    border: none;
  }

  .footer-bottom {
    font-size: 0.8rem;
  }
}

/* ========================= */
/* 💬 Floating Chat Styles  */
/* ========================= */
.chat-icon {
  position: fixed;
  bottom: 25px;
  right: 25px;
  background-color: #00703C;
  color: white;
  border: none;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 10000;
}

.chat-icon:hover {
  background-color: #E22B2B;
  transform: scale(1.1);
}

.chat-popup {
  position: fixed;
  bottom: 90px;
  right: 25px;
  background: white;
  border: 2px solid #00703C;
  border-radius: 12px;
  padding: 1rem;
  width: 320px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  z-index: 10001;
  animation: popupFadeIn 0.3s ease-in-out;
}

@keyframes popupFadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

.chat-popup h3 {
  margin-top: 0;
  color: #00703C;
  text-align: center;
  font-size: 1.1rem;
  border-bottom: 2px solid #E22B2B;
  padding-bottom: 0.4rem;
  margin-bottom: 0.6rem;
}

.chat-popup form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.chat-popup input,
.chat-popup textarea {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  box-sizing: border-box;
}

.chat-popup input.error,
.chat-popup textarea.error {
  border: 2px solid #ff4444;
}

.error-message {
  color: #ff4444;
  font-size: 11px;
  display: block;
  margin-top: 2px;
}

.chat-popup textarea {
  resize: none;
  height: 80px;
}

.send-btn {
  background-color: #00703C;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.6rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight: 600;
}

.send-btn:hover {
  background-color: #E22B2B;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  color: #333;
}

@media (max-width: 500px) {
  .chat-popup {
    right: 10px;
    width: 90%;
    bottom: 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B,6BAA6B;AAC7B,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B,6BAA6B;AAC7B,8BAA8B;AAC9B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":["/* ========================= */\n/* 🌿 Main Footer Section   */\n/* ========================= */\n.footer {\n  background-color: #00703C;\n  color: white;\n  padding: 2rem 1rem 1rem;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);\n  margin-top: 3rem;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 2rem;\n  max-width: 1100px;\n  margin: auto;\n}\n\n/* Left Section */\n.footer-logo {\n  flex: 1;\n  min-width: 250px;\n  text-align: center;\n}\n\n.footer-logo img {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  background-color: white;\n  margin-bottom: 0.5rem;\n}\n\n.footer-logo h3 {\n  margin: 0.2rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.footer-motto {\n  font-style: italic;\n  color: #FFD700;\n  font-size: 0.9rem;\n}\n\n/* ABN display — required by NAB */\n.footer-abn {\n  font-size: 0.82rem;\n  color: rgba(255,255,255,0.75);\n  margin: 0.15rem 0;\n}\n\n/* Middle Section */\n.footer-links {\n  flex: 1;\n  min-width: 200px;\n}\n\n.footer-links h4 {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  border-bottom: 2px solid #E22B2B;\n  display: inline-block;\n  padding-bottom: 3px;\n}\n\n.footer-links ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-links li {\n  margin: 0.4rem 0;\n}\n\n.footer-links a {\n  color: white;\n  text-decoration: none;\n  transition: color 0.3s;\n}\n\n.footer-links a:hover {\n  color: #FFD700;\n}\n\n/* Right Section */\n.footer-contact {\n  flex: 1;\n  min-width: 200px;\n}\n\n.footer-contact h4 {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  border-bottom: 2px solid #E22B2B;\n  display: inline-block;\n  padding-bottom: 3px;\n}\n\n.footer-contact p {\n  margin: 0.3rem 0;\n  font-size: 0.95rem;\n}\n\n/* Legal links — Privacy Policy, Refund Policy */\n.footer-legal-links {\n  list-style: none;\n  padding: 0;\n  margin: 0.4rem 0 1rem;\n}\n\n.footer-legal-links li {\n  margin: 0.3rem 0;\n}\n\n.footer-legal-links a {\n  color: #FFD700;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s;\n}\n\n.footer-legal-links a:hover {\n  text-decoration: underline;\n}\n\n/* NAB payment security note */\n.footer-payment-note {\n  font-size: 0.8rem;\n  color: rgba(255,255,255,0.75);\n  background: rgba(0,0,0,0.15);\n  border-radius: 6px;\n  padding: 8px 10px;\n  margin-top: 0.75rem;\n  line-height: 1.6;\n}\n\n/* Bottom Bar */\n.footer-bottom {\n  text-align: center;\n  margin-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n  padding-top: 0.8rem;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* Responsive Footer */\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .footer-links h4,\n  .footer-contact h4 {\n    border: none;\n  }\n\n  .footer-bottom {\n    font-size: 0.8rem;\n  }\n}\n\n/* ========================= */\n/* 💬 Floating Chat Styles  */\n/* ========================= */\n.chat-icon {\n  position: fixed;\n  bottom: 25px;\n  right: 25px;\n  background-color: #00703C;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.6rem;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  z-index: 10000;\n}\n\n.chat-icon:hover {\n  background-color: #E22B2B;\n  transform: scale(1.1);\n}\n\n.chat-popup {\n  position: fixed;\n  bottom: 90px;\n  right: 25px;\n  background: white;\n  border: 2px solid #00703C;\n  border-radius: 12px;\n  padding: 1rem;\n  width: 320px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);\n  z-index: 10001;\n  animation: popupFadeIn 0.3s ease-in-out;\n}\n\n@keyframes popupFadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.chat-popup h3 {\n  margin-top: 0;\n  color: #00703C;\n  text-align: center;\n  font-size: 1.1rem;\n  border-bottom: 2px solid #E22B2B;\n  padding-bottom: 0.4rem;\n  margin-bottom: 0.6rem;\n}\n\n.chat-popup form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.chat-popup input,\n.chat-popup textarea {\n  width: 100%;\n  padding: 0.6rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  box-sizing: border-box;\n}\n\n.chat-popup input.error,\n.chat-popup textarea.error {\n  border: 2px solid #ff4444;\n}\n\n.error-message {\n  color: #ff4444;\n  font-size: 11px;\n  display: block;\n  margin-top: 2px;\n}\n\n.chat-popup textarea {\n  resize: none;\n  height: 80px;\n}\n\n.send-btn {\n  background-color: #00703C;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.6rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-weight: 600;\n}\n\n.send-btn:hover {\n  background-color: #E22B2B;\n}\n\n.close-btn {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  background: transparent;\n  border: none;\n  font-size: 1.1rem;\n  cursor: pointer;\n  color: #333;\n}\n\n@media (max-width: 500px) {\n  .chat-popup {\n    right: 10px;\n    width: 90%;\n    bottom: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
